export default function(targetSlice) {
    const liveChatElements = targetSlice.querySelectorAll("a[href='live-chat']");
    const liveChatElementsLength = liveChatElements.length;
    if (liveChatElementsLength <= 0) {
        return;
    }
    for (let index = 0; index < liveChatElementsLength; index++) {
        liveChatElements[index].addEventListener('click', function(e) {
            e.preventDefault()
            window.liveChatClass.openLiveChat();
        })
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/cms-content-slices/modules/setup-live-chat-buttons.js